import breaches from '../pages/csc/breaches';
import details from '../pages/csc/details';
import disability from '../pages/csc/disability';
import ethnicity from '../pages/csc/ethnicity';
import exceptions from '../pages/csc/exceptions';
import exceptionsBreakdown from '../pages/csc/exceptionsBreakdown';
import externalByDefault from '../pages/csc/externalByDefault';
import fairAndOpen from '../pages/csc/fairAndOpen';
import gender from '../pages/csc/gender';
import internalCompetitions from '../pages/csc/internalCompetitions';
import lifeChances from '../pages/csc/lifeChances';
import recruitementActivity from '../pages/csc/recruitementActivity';
import recruitmentCampaigns from '../pages/csc/recruitmentCompaigns';
import recruitmentFunctions from '../pages/csc/recruitmentFunctions';
import scsAppointments from '../pages/csc/scsAppointments';
import {
  REPORTING_PERIOD,
  REPORTING_QUARTER,
  SUBMISSION_DEADLINE,
} from '../pages/csc/shared_variables';
import type { FormConfig } from '../types';

const formConfig: FormConfig = {
  live: true,
  id: 'csc',
  formName: 'CS Commission',
  title: 'Civil Service Commission',
  subTitle: 'Summary',
  submissionDeadlineBannerText: `The submission deadline is ${SUBMISSION_DEADLINE}`,
  register: true,
  identifier: '{department}',
  showSections: true,
  approval: 'optional',
  approvalAllowUnsubmit: true,
  statusOverride: {
    submitted: 'Submitted',
  },
  formCloseAt: '2026-04-30T17:00',
  allowUnlock: 'formClose',
  sections: [
    {
      title: `CS Commission - ${REPORTING_QUARTER}`,
      slug: 'your-quarterly-data-return',
      subsections: [
        {
          title: 'Details',
          slug: 'details',
          pages: details,
        },
        {
          title: 'Recruitment Campaigns',
          slug: 'recruitment-campaigns',
          pages: recruitmentCampaigns,
        },
        {
          title: 'Recruitment activity',
          slug: 'recruitment-activity',
          pages: recruitementActivity,
        },
        {
          title: 'Fair and open',
          slug: 'fair-and-open',
          pages: fairAndOpen,
        },
        {
          title: 'Gender',
          slug: 'gender',
          pages: gender,
        },
        {
          title: 'Ethnicity',
          slug: 'ethnicity',
          pages: ethnicity,
        },
        {
          title: 'Disability',
          slug: 'disability',
          pages: disability,
        },
        {
          title: 'Exceptions',
          slug: 'exceptions',
          pages: exceptions,
        },
        {
          title: 'Exceptions breakdown',
          slug: 'exceptions-breakdown',
          pages: exceptionsBreakdown,
        },
        {
          title: 'Breaches',
          slug: 'breaches',
          pages: breaches,
        },
        {
          title: 'Recruitment function',
          slug: 'recruitment-function',
          pages: recruitmentFunctions,
        },
        {
          title: 'GFIE Pathways',
          slug: 'life-chances',
          pages: lifeChances,
        },
        {
          title: 'External by default',
          slug: 'external-by-default',
          pages: externalByDefault,
        },
        {
          title: 'Internal competitions',
          slug: 'internal-competitions',
          pages: internalCompetitions,
        },
        {
          title: 'SCS appointments',
          slug: 'scs-appointments',
          pages: scsAppointments,
        },
      ],
    },
  ],
};
export default formConfig;
